//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useContext, useState } from 'react';

import { ISchedulerSharedState } from '@universal-scheduling/contexts/scheduler/schedulerSharedStateModels';
import { getSmartInputUIRefreshKey } from '@universal-scheduling/contexts/scheduler/utils/schedulerContextUtils';

export const SCHEDULER_SHARED_STATE_DEFAULT_VALUES: ISchedulerSharedState = {
  smartInputCaptionRefreshKey: getSmartInputUIRefreshKey('caption'),
  postDetailsTabData: [],
  sharedPostNow: false,
  postedPost: undefined,
  postTimeFailureMessages: [],
  scheduleTimeFailureMessages: [],
  selectedMedia: [],
  mediaErrors: [],
  sharedCaption: '',
  sharedScheduledTime: undefined,
  syncTabNetworkFormKey: undefined,
  hasSynced: false,
};

export const SCHEDULER_PROVIDER_INITIAL_VALUES: ISchedulerProviderValues = {
  ...SCHEDULER_SHARED_STATE_DEFAULT_VALUES,
  setSharedState: (prevState: React.SetStateAction<ISchedulerSharedState>) => {
    return prevState;
  },
};

const SchedulerContext = React.createContext<ISchedulerProviderValues>(
  SCHEDULER_PROVIDER_INITIAL_VALUES,
);

export const useSchedulerContext = () => {
  return useContext(SchedulerContext);
};

export interface ISchedulerProviderValues extends ISchedulerSharedState {
  setSharedState: React.Dispatch<React.SetStateAction<ISchedulerSharedState>>;
}

export interface Props {
  initialState: ISchedulerSharedState;
  children: React.ReactNode;
}

export const SchedulerContextProvider = ({ initialState, children }: Props) => {
  const [sharedState, setSharedState] =
    useState<ISchedulerSharedState>(initialState);

  return (
    <SchedulerContext.Provider
      value={{
        ...sharedState,
        setSharedState,
      }}
    >
      {children}
    </SchedulerContext.Provider>
  );
};
